import { API_HANDLERS, DatasetPanoramasResponse, GET, ProjectDatasetResponse } from 'api';
import { AxiosError } from 'axios';

interface CheckFileNameOptions {
    itemPathUrl: string;
    storageName: string;
    projectToken: string;
    onError?: (error: any) => void;
}

interface LoadListDatasetsOptions {
    projectId: string;
    token: string;
    onSuccess: (data: ProjectDatasetResponse) => void;
    onError: (data: AxiosError) => void;
}

interface LoadListPanoramasOptions {
    projectId: string;
    datasetId: string;
    token: string;
    onSuccess: (data: DatasetPanoramasResponse) => void;
    onError: (data: AxiosError) => void;
}

export async function checkFilename({ itemPathUrl, storageName, projectToken, onError }: CheckFileNameOptions) {
    let objext = null;

    try {
        const res = await GET(itemPathUrl, {
            timeout: 3 * 1000, // ms
            headers: {
                'Cache-Control': 'no-cache',
                XStorageName: storageName,
                Authorization: `Bearer ${projectToken}`,
            },
        });

        objext = {
            filepath: res.headers.pspmethod as string,
        };

        return objext;
    } catch (error: any) {
        onError?.(error);
        return null;
    }
}

export function actionFetchAndLoadListDatasetsByProjectId({
    projectId,
    token,
    onSuccess,
    onError,
}: LoadListDatasetsOptions) {
    API_HANDLERS.PSP.PROJECT.DATASET({
        projectId,
        token,
    })
        .then((response) => {
            onSuccess(response.data);
        })
        .catch(onError);
}

export function actionFetchAndLoadPanoramasByDatasetId({
    projectId,
    datasetId,
    token,
    onSuccess,
    onError,
}: LoadListPanoramasOptions) {
    API_HANDLERS.PSP.DATASET.PANORAMAS({
        projectId,
        datasetId,
        token,
    })
        .then((response) => {
            onSuccess(response.data);
        })
        .catch(onError);
}
